<template>
  <div id="app">
    <!-- <router-link to="/">home</router-link> -->
    <router-view></router-view>
  </div>
</template>

<script>
import VConsole from 'vconsole';
if (process.env.NODE_ENV === 'development' || window.location.search.includes('vconsole=yes_do_open')) {
  new VConsole();
}
export default {
  name: "App",
  components: {},
  mounted() {
    // this.$xh.removeCookie("_XH_COMMON_WECHAT",'.rastargame.com');
    // new VConsole();
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: url(../src/assets/bg.png) no-repeat center;
  background-size: 100% auto;
  padding-bottom: 1rem;
}
</style>
